/**
 * 将表格数据中的数值转换为风险等级文本
 *
 * @param tableData 表格数据（二维数组）
 * @param startCol 开始处理的列索引 (默认为3)
 * @param endCol 结束处理的列索引 (默认为11)
 * @returns 处理后的表格数据
 */
export function convertNumToRiskLevel(
  t: any,
  tableData: any[][],
  call: (t: any, value: any) => string,
  startCol: number = 3,
  endCol: number = 11
): any[][] {
  // 使用更高效的深拷贝方法
  const result = JSON.parse(JSON.stringify(tableData));

  // 遍历表格的每一行
  result.forEach((row: any) => {
    // 仅处理指定范围内的列
    for (let j = startCol; j <= endCol && j < row.length; j++) {
      const cell = row[j];

      // 跳过空单元格
      if (cell === null || cell === undefined) continue;

      if (typeof cell === "object") {
        // 处理对象类型单元格
        if (cell && "text" in cell && cell.text !== null) {
          // 保持单元格样式不变，仅转换文本内容
          cell.text = call(t, cell.text); //这个函数从外部参数传进来
        }
      } else {
        // 处理直接值类型的单元格
        row[j] = call(t, cell);
      }
    }
  });

  return result;
}
